import { render, staticRenderFns } from "./plan_select_register.vue?vue&type=template&id=624c6de4&scoped=true&lang=pug&"
import script from "./plan_select_register.vue?vue&type=script&lang=js&"
export * from "./plan_select_register.vue?vue&type=script&lang=js&"
import style0 from "./plan_select_register.vue?vue&type=style&index=0&id=624c6de4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "624c6de4",
  null
  
)

export default component.exports